export default "__VITE_ASSET__BqLOX$GZ__"